import { render, staticRenderFns } from "./ProdutoEditar.vue?vue&type=template&id=22caf8b2"
import script from "./ProdutoEditar.vue?vue&type=script&lang=js"
export * from "./ProdutoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports